module.exports = __webpack_public_path__ + "img/certificateImg.8de992d0.png";